const ParamsToHash = str =>
  Object.fromEntries(str.split("&").map(item => item.split("=")));
export default ParamsToHash;
